import { Typography, FormHelperText } from '@mui/material'
import { Box, Stack } from '@mui/system'
import DateFilter from 'components/DateFilter'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'


const FormDateRangeInput = ({
  required,
  startsAtName = 'starts_at',
  endsAtName = 'ends_at',
  ...props
}) => {
  const { t } = useTranslation()
  const { register, setValue, formState, watch } = useFormContext()

  const startsAt = watch(startsAtName)
  const endsAt = watch(endsAtName)
  return (
    <Stack>
      <input type={'hidden'} {...register(startsAtName)} />
      <input type={'hidden'} {...register(endsAtName)} />
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          fontSize: '12px',
          lineHeight: '24px',
          fontWeight: '400',
          color: 'content.secondary'
        }}>
        <Typography
          sx={{
            fontSize: '12px',
            lineHeight: '24px',
            fontWeight: '400',
            visibility: props.label ? 'visible' : 'hidden'
          }}>{`${props.label}${required ? '*' : ' '}`}</Typography>
      </Stack>
      <Stack>
        <DateFilter
          placement='right-start'
          startDate={startsAt}
          endDate={endsAt}
          displayStartAdornment={false}
          allowPastDate={false}
          placeholderKey={t('advertisements.edition.content.date_placeholder')}
          onReset={() => {
            setValue(startsAtName, null, {
              shouldValidate: true,
              shouldDirty: true
            })
            setValue(endsAtName, null, {
              shouldValidate: true,
              shouldDirty: true
            })
          }}
          onStartDateChange={d => {
            setValue(startsAtName, d, {
              shouldValidate: true,
              shouldDirty: true
            })
          }}
          onEndDateChange={d => {
            setValue(endsAtName, d, {
              shouldValidate: true,
              shouldDirty: true
            })
          }}
          inputSx={{
            width: '100%',
            height: '39px',
            border: '2px solid border.primary',
            background: 'white',
            '&:hover': {
              borderColor: 'common.accent' // - Set the Input border when parent has :hover
            },
            ...(formState.errors[startsAtName] || formState.errors[endsAtName] ? { border: 'solid 1px red' } : {})
          }}
        />
        <Box sx={{ minHeight: '28px' }}>
          {(formState.errors[startsAtName] || formState.errors[endsAtName]) && (
            <FormHelperText error>
              {formState.errors[startsAtName]?.message || formState.errors[endsAtName]?.message}
            </FormHelperText>
          )}
        </Box>
      </Stack>
    </Stack>
  )
}

export default FormDateRangeInput
